import { module } from 'angular';
import { MailboxPageComponent } from './pages';
import { mailboxRoutesConfig } from './mailbox-routing';
import { GmcPaginationModule } from '../../ui/gmc-pagination/gmc-pagination.module';
import { MailboxService } from './services';
import { MailBodyComponent, MailItemComponent, MailsGroupComponent } from './components';
import { CheckDropdownSelectModule } from '../../ui/check-dropdown-select/check-dropdown-select.module';

export const MailboxModule = module('app.states.mailbox', [
  GmcPaginationModule,
  CheckDropdownSelectModule
])
  .component('mailboxPage', MailboxPageComponent)
  .component('mailItem', MailItemComponent)
  .component('mailsGroup', MailsGroupComponent)
  .component('mailBody', MailBodyComponent)
  .service(MailboxService.name, MailboxService)
  .config(mailboxRoutesConfig);



// WEBPACK FOOTER //
// ./app/states/mailbox/mailbox.module.ts